import { Link } from "react-router-dom";
import { Star, SunDoodle } from "./Illustrations";
import { Flower, Spiral, Heart } from "./Doodles";
import Reveal from "./Reveal";
import MagneticButton from "./MagneticButton";

/** Quiz teaser strip — playful colour-block band that nudges parents to the quiz. */
export default function QuizTeaser() {
  return (
    <section className="relative px-5 md:px-10 py-20 md:py-28 overflow-hidden bg-[#FAFAF7]" data-testid="quiz-teaser">
      <div className="relative mx-auto max-w-[1200px] rounded-[32px] overflow-hidden">
        {/* Striped colour band background */}
        <div className="absolute inset-0 -z-0 flex" aria-hidden>
          <div className="flex-1 bg-[#F4C734]" />
          <div className="flex-1 bg-[#EE8C72]" />
          <div className="flex-1 bg-[#8BC547]" />
          <div className="flex-1 bg-[#A9CDE5]" />
          <div className="flex-1 bg-[#C6B9D6]" />
        </div>
        <div className="absolute inset-3 -z-0 rounded-[26px] bg-[#FAFAF7]" aria-hidden />

        <Flower size={56} color="#DD2E20" center="#F4C734" className="absolute top-6 left-8 wiggle hidden md:block" />
        <SunDoodle size={50} className="absolute top-8 right-10 spin-slow hidden md:block" />
        <Spiral size={40} className="absolute bottom-8 left-14 hidden md:block" color="#8BC547" />
        <Heart size={28} className="absolute bottom-8 right-14 wiggle hidden md:block" />
        <Star size={20} color="#DD2E20" className="absolute top-1/2 left-6 wiggle" />
        <Star size={18} color="#F4C734" className="absolute top-1/2 right-8 wiggle" />

        <div className="relative px-6 md:px-14 py-14 md:py-20 text-center">
          <Reveal>
            <p className="eyebrow mb-3">A 60-second quiz</p>
          </Reveal>
          <Reveal delay={60}>
            <h2 className="font-serif text-4xl md:text-6xl lg:text-7xl leading-[1] tracking-[-0.025em]">
              Not sure which pair? <br className="hidden md:block" />
              <span className="italic" style={{ color: "#DD2E20" }}>Let's find</span> their match.
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <p className="mt-5 text-[#595955] text-base md:text-lg max-w-[44ch] mx-auto">
              Four playful questions about your kid. One recommendation that just fits.
            </p>
          </Reveal>
          <Reveal delay={180}>
            <div className="mt-9 flex flex-wrap items-center justify-center gap-3">
              <MagneticButton>
                <Link
                  to="/quiz"
                  className="inline-flex items-center gap-2 rounded-full bg-[#2C2C2A] text-[#FAFAF7] px-7 py-4 text-[15px] font-medium hover:bg-[#1A1A18] transition-colors"
                  data-testid="quiz-teaser-cta"
                >
                  Match my child →
                </Link>
              </MagneticButton>
              <span className="text-[12px] text-[#595955] tracking-[0.18em] uppercase">Free · 60 sec · No sign-up</span>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
